import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { CardHeader, Col, Modal, Row } from 'reactstrap'

import './style.css'
import { closeQuizOverlay } from 'store/Quiz/actions'

const CustomModal = (props) => {
  const [showModal, setShowModal] = useState(true)
  const handleCloseModal = () => setShowModal(false)
  const history = useHistory()

  // console.log('props.children in modal', props.children)

  useEffect(() => {
    if (!showModal && props.isSubmission) {
      history.push(`/course/${props.courseId}`)
    }
  }, [showModal])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => {
        if (props.isSubmission) {
          handleCloseModal()
        } else {
          props.dispatch(closeQuizOverlay(() => handleCloseModal()))
        }
      }}
      centered
      size={props.size}
      style={props.style}
      className={props.className}
      enforceFocus={false}
    >
      {props.children}
    </Modal>
  )
}

export default CustomModal
